import { OrderRecoveryPage } from 'rentalui-finance';
import { client } from '../api';
import { useAuth } from '../auth';

export default function OrderRecoveryScreen() {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin' || user?.roles?.includes('admin');
  return <OrderRecoveryPage client={client} isAdmin={isAdmin} viewerKey={user?.id || user?.email} />;
}
